import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconDelete = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M9.75 9C10.1642 9 10.5 9.33579 10.5 9.75V17.14C10.5 17.5542 10.1642 17.89 9.75 17.89C9.33579 17.89 9 17.5542 9 17.14V9.75C9 9.33579 9.33579 9 9.75 9Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15 9.75C15 9.33579 14.6642 9 14.25 9C13.8358 9 13.5 9.33579 13.5 9.75V16.75C13.5 17.1642 13.8358 17.5 14.25 17.5C14.6642 17.5 15 17.1642 15 16.75V9.75Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M11.0002 1.98999C9.4815 1.98999 8.25 3.22111 8.25 4.73999V5.08002H3.78998C3.37576 5.08002 3.03998 5.4158 3.03998 5.83002C3.03998 6.24423 3.37576 6.58002 3.78998 6.58002H4.75V18.24C4.75 20.3111 6.42893 21.99 8.5 21.99H15.4894C17.5605 21.99 19.2394 20.3111 19.2394 18.24V6.58002H20.21C20.6242 6.58002 20.96 6.24423 20.96 5.83002C20.96 5.4158 20.6242 5.08002 20.21 5.08002H15.75V4.73999C15.75 3.22111 14.5185 1.98999 12.9998 1.98999H11.0002ZM9.75 4.73999C9.75 4.04973 10.3097 3.48999 11.0002 3.48999H12.9998C13.6903 3.48999 14.25 4.04973 14.25 4.73999V5.06999H9.75V4.73999ZM6.25 6.58002H17.7394V18.24C17.7394 19.4827 16.7321 20.49 15.4894 20.49H8.5C7.25736 20.49 6.25 19.4827 6.25 18.24V6.58002Z",
			fill: "currentColor"
		})
	]
});
export { SvgIconDelete as ReactComponent };
